(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/pix-banner/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/racing/pix-banner/assets/javascripts/prescript.js');
"use strict";


svs = svs || {};
svs.racing = svs.racing || {};
svs.racing.pix_banner = svs.racing.pix_banner || {};

 })(window);